import { render, staticRenderFns } from "./right3.vue?vue&type=template&id=3976021a&scoped=true"
import script from "./right3.vue?vue&type=script&lang=js"
export * from "./right3.vue?vue&type=script&lang=js"
import style0 from "./right3.vue?vue&type=style&index=0&id=3976021a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3976021a",
  null
  
)

export default component.exports